import React, { FC, MouseEventHandler } from 'react';

import CardContent from '../Card/CardContent';
import CardMain from '../Card/CardMain';
import Container from '../Container';

import AccountHelpersCardAppendix from './AccountHelpersCardAppendix';
import RequestPasswordResetForm from './forms/RequestPasswordResetForm';
import SignInForm from './forms/SignInForm';
import SignUpForm from './forms/SignUpForm';

export interface SessionForm {
  component: FC<{ redirectUrl?: string }>;
  name: string;
  path: string;
}

export const sessionForms: SessionForm[] = [
  { path: '/u/session/new', name: 'Inloggen', component: SignInForm },
  { path: '/u/registration/new', name: 'Account aanmaken', component: SignUpForm },
  { path: '/u/password/new', name: 'Wachtwoord vergeten?', component: RequestPasswordResetForm },
];

const SessionForm = ({
  form,
  onFormChange,
  redirectUrl,
}: {
  form: SessionForm;
  onFormChange?: MouseEventHandler<HTMLAnchorElement>;
  redirectUrl?: string;
}) => {
  const Component = form.component;

  return (
    <Container>
      <CardMain>
        <CardContent endSpacing>
          <Component redirectUrl={redirectUrl} />
        </CardContent>
        <AccountHelpersCardAppendix currentPath={form.path} redirectUrl={redirectUrl} onClick={onFormChange} />
      </CardMain>
    </Container>
  );
};

export default SessionForm;
